<div class="flex flex-col">
  <div class="flex flex-row">
    <span class="text-light">{{item()['baureihe']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()['bezeichnung']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="text-light">{{item()['marke']}}</span>
  </div>
</div>
